<template>
  <transition appear name="v--mask">
    <footer v-once class="blog__footer">
      Gerade Geldenhuys | Copyright &copy; {{ new Date().getFullYear() }}
    </footer>
  </transition>
</template>

<script>
export default { name: 'blog-footer' }
</script>



// WEBPACK FOOTER //
// src/components/BlogFooter.vue